<template>

<div>
    <div class="row">
        <div class="col-12 profile-navigation d-flex justify-content-center">
            <ul class="nav tab-nav mt-0 mb-4 mb-md-5">
                <li id="marker"></li>
                
                <li class="nav-item">
                    <a href="#" @click='setType(false)' :class='["nav-link", { active : !type }]'>Всички проекти</a>
                </li>

                <li v-for='t in types' class="nav-item">
                    <a href="#" @click='setType(t.id)' 
                       :class='["nav-link", { active : t.id == type }]'>
                        
                        {{ t.name }}       
                    </a>
                </li>
            </ul>

        </div>
    </div>

    <div class="row">
        <loading-div v-if='isLoading || !isReady'></loading-div>
        <div v-for='p in projects' v-if='!isLoading && isReady' class="col-lg-4 col-sm-6 mb-4 mb-md-5">
            <div class="list-item shadow-lg h-100 project-item">
                <div class="list-img">
                    <a class="lp-box-link" :href='"/projects/" + p.slug'>
                        
                        <img class="img-responsive" 
                             :src="p.image ? p.image : '/resources/images/def-img.jpg'">
                        
                        <div class="list-label">

                            <span v-if='p.phase' class="capt">Етап:</span>
                            <span v-if='p.phase' class="cont">{{ p.phase }}</span>

                            <span v-if='!p.phase && p.finished == 1' class="capt">Завършен проект</span>
                            <span v-if='!p.phase && p.finished == 0' class="capt">Няма активен етап</span>

                        </div>
                        <span class="overlay d-flex align-items-center justify-content-center">
                            <span class="overlay-inner text-center">
                                <span class="icon icon-chevrons-right"></span>
                                <span class="text mt-3">Вижте още</span>
                            </span>
                        </span>
                    </a>
                </div>

                <div class="list-info p-4">
                    <h4 class="text-center">
                        <a :href='"/projects/" + p.slug'>
                            {{ p.name }}
                        </a>
                    </h4>
                </div>

                <div class="list-bottom">
                    <ul class="list-unstyled list-inline">
                        <li class="list-inline-item">
                            <span class="icon icon-flag"></span>
                            {{ p.city }}
                        </li>
                        <li class="list-inline-item">
                            <span class="icon icon-folder"></span>
                            {{ p.type }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>   

        <div class='col-12 alert alert-info' v-if='!projects.length && isReady'>
            Няма резултати
        </div>  
    </div>

    <div v-if='total > projects.length' class="row">
        <div class="col-12 text-center">
            <button @click='getData()' class="btn btn-outline-primary">
                <span class="icon icon-refresh-cw"></span>
                Зареждане на още
            </button>  
        </div>
    </div>

</div>

</template>

<script>
    export default {

        mounted() {
        
            this.getData();
        
        },

        created() {
           
        },

        props : ['f'],

        data() {
            return {
                
                isReady   : false,
                isLoading : false,

                types : [],
                total : 0,
                type : false,

                projects : [],

            }
        },

        methods : {

            setType( t ) {
                if( t == this.type ){
                    return;
                }

                this.isReady = false;
                this.type = t;
                this.projects = [];

                this.getData();
            },

            getData() {

                var me = this, 
                    data = {};

                if( !this.isReady ) {
                    //Initial pull
                    data.init = 1;
                }

                if( this.type ) {
                    //Initial pull
                    data.t = this.type;
                }

                if( typeof this.f != 'undefined' ) {
                    data.f = this.f;
                } else {
                    data.f = 0;
                }

                data.skip = this.projects.length;

                me.isLoading = true;

                me.ajax.call('prj:gpl', data, (r) => {
                    
                    me.isLoading = false;

                    if( r.status == 'success' ) {

                        if( !me.isReady ) {
                            //Initial pull 
                            me.projects = r.data.p;
                            me.total   = r.data.t;
                            me.types   = r.data.tp;
                            me.isReady = true;
                        
                        } else {

                            me.projects = me.projects.concat( r.data.p );

                        }

                    }

                })

            }

        }

    }
</script>
